export const CONNECTIVITY_PIP_OPEN_EVENT = 'calloperator:connectivity-pip-open'
export const CONNECTIVITY_PIP_CLOSE_EVENT = 'calloperator:connectivity-pip-close'
